<div class="dashboard--module-header">
    <h2 class="subheading-sm">Total Portfolio Account Balance <button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<cumlative-account-balance-chart class="module--main" [(hasData)]="hasData" [(hasLoading)]="hasLoading" *ngIf="hasLoading || hasData; else noData"></cumlative-account-balance-chart>
<ng-template style="text-align:center" #noData><p class="text-center">No data available</p></ng-template>
